var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.homeData)?_c('div',{staticClass:"brand-list"},[_c('BrandProduct',{attrs:{"title":"美妆商品","describe":"自营品牌","brand-id":3,"list":_vm.homeData.mzList,"img-list":_vm.homeData.mzimgList}}),_c('BrandProduct',{attrs:{"title":"大健康商品","describe":"澳洲直邮","brand-id":4,"list":_vm.homeData.djkList,"img-list":_vm.homeData.djkimgList}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }